(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405,948],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(43474);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45388);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n    border-radius: 0px;\n    width: ",
        ";\n    background: transparent;\n    color: ",
        ";\n    border: none;\n    &:disabled{\n        background: transparent;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var IconButtonV2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4053ef80-0"
})(_templateObject(), function(param) {
    var scale = param.scale;
    return scale === "sm" ? "32px" : "48px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
/* harmony default export */ __webpack_exports__["Z"] = (IconButtonV2);


/***/ }),

/***/ 54379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8774);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    appearance: none;\n    overflow: hidden;\n    cursor: pointer;\n    display: flex;\n    height: ",
        ";\n    width: ",
        ";\n    vertical-align: middle;\n    transition: background-color 0.2s ease-in-out;\n    border: 0;\n    border-radius: 50%;\n    background-color: transparent;\n    border: 2px solid ",
        ';\n    align-items: center;\n    justify-content: center;\n    &:after {\n        content: "";\n        width: 50%;\n        height: 50%;\n        margin: auto;\n        transition: border-color 0.2s ease-in-out;\n        border-radius: 50%;\n    }\n    &:checked {\n        background-color: ',
        ";\n        border: none;\n        &:after {\n            background-color: ",
        ";\n        }\n    }\n\n    &:disabled {\n        cursor: default;\n        background-color: ",
        ';\n        opacity: 0.6;\n        &:after {\n            content: "";\n            width: 50%;\n            height: 25%;\n            margin: auto;\n            transform: rotate(-50deg);\n            transition: border-color 0.2s ease-in-out;\n            border-color: ',
        ";\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var getScale = function(param) {
    var scale = param.scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "24px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "32px";
    }
};
var CheckboxV2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.attrs */ .ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-305883aa-0"
})(_templateObject(), getScale, getScale, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
CheckboxV2.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    checked: false
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxV2);


/***/ }),

/***/ 8774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md"
};


/***/ }),

/***/ 16080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 21 21"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.6131 3.673C13.5894 2.69669 15.1723 2.69669 16.1486 3.673L17.3271 4.85151C18.3034 5.82782 18.3034 7.41073 17.3271 8.38704L8.66669 17.0475C8.55035 17.1638 8.40219 17.2431 8.24086 17.2754L3.82145 18.1592C3.23834 18.2759 2.72424 17.7618 2.84086 17.1787L3.72475 12.7592C3.75701 12.5979 3.83631 12.4498 3.95264 12.3334L12.6131 3.673ZM14.9701 4.85151L16.1486 6.03002C16.474 6.35546 16.474 6.8831 16.1486 7.20853L14.9701 8.38705L12.6131 6.03002L13.7916 4.85151C14.117 4.52607 14.6447 4.52607 14.9701 4.85151ZM11.4346 7.20853L5.30957 13.3335L4.72031 16.2798L7.66659 15.6905L13.7916 9.56556L11.4346 7.20853Z",
            fill: "#6F767E"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 51948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30693);



var stocksSupport = [
    {
        id: 27,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo28 */ .dI.Demo28
    },
    {
        id: 26,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo27 */ .dI.Demo27
    },
    {
        id: 25,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo26 */ .dI.Demo26
    },
    {
        id: 24,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo25 */ .dI.Demo25
    },
    {
        id: 23,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo24 */ .dI.Demo24
    },
    {
        id: 22,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo23 */ .dI.Demo23
    },
    {
        id: 21,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo22 */ .dI.Demo22
    },
    {
        id: 20,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo21 */ .dI.Demo21
    },
    {
        id: 19,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo20 */ .dI.Demo20
    },
    {
        id: 18,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo19 */ .dI.Demo19
    },
    {
        id: 17,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo18 */ .dI.Demo18
    },
    {
        id: 16,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo17 */ .dI.Demo17
    },
    {
        id: 15,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo16 */ .dI.Demo16
    },
    {
        id: 14,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo15 */ .dI.Demo15
    },
    {
        id: 13,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo14 */ .dI.Demo14
    },
    {
        id: 12,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo13 */ .dI.Demo13
    },
    {
        id: 11,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo12 */ .dI.Demo12
    },
    {
        id: 10,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo11 */ .dI.Demo11
    },
    {
        id: 9,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo10 */ .dI.Demo10
    },
    {
        id: 8,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo9 */ .dI.Demo9
    },
    {
        id: 7,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo8 */ .dI.Demo8
    },
    {
        id: 6,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo7 */ .dI.Demo7
    },
    {
        id: 5,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo6 */ .dI.Demo6
    },
    {
        id: 4,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo5 */ .dI.Demo5
    },
    {
        id: 3,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo4 */ .dI.Demo4
    },
    {
        id: 2,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo3 */ .dI.Demo3
    },
    {
        id: 1,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo2 */ .dI.Demo2
    },
    {
        id: 0,
        contract: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTestnetTokens.Demo1 */ .dI.Demo1
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        contract: p.contract.serialize
    });
});
/* harmony default export */ __webpack_exports__["default"] = (stocksSupport);


/***/ }),

/***/ 43474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(2726);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/views/Auth/index.tsx + 1 modules
var Auth = __webpack_require__(27866);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(55421);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(32437);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(15004);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/state/home/index.ts
var home = __webpack_require__(61557);
// EXTERNAL MODULE: ./src/state/home/actions.ts
var actions = __webpack_require__(51302);
// EXTERNAL MODULE: ./src/state/index.ts + 37 modules
var state = __webpack_require__(3962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(76376);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Copy.tsx
var Copy = __webpack_require__(84298);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(17235);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 2 modules
var Toast = __webpack_require__(14605);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 22 modules
var useContract = __webpack_require__(73740);
;// CONCATENATED MODULE: ./src/hooks/useUserRejected.tsx

var useUserRejected = function() {
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var handleRejected = function(error) {
        var stringifyError = JSON.stringify(error);
        var parseError = JSON.parse(stringifyError);
        console.log(parseError);
        if ((parseError === null || parseError === void 0 ? void 0 : parseError.code) === "ACTION_REJECTED") toastError("Người d\xf9ng đ\xe3 từ chối thực hiện giao dịch");
        else toastError("Đ\xe3 c\xf3 lỗi xảy ra", "X\xe1c nhận giao dịch v\xe0 đảm bảo rằng bạn đủ tiền trong v\xed để xử l\xfd giao dịch !");
    };
    return {
        handleRejected: handleRejected
    };
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/web3-validator/lib/esm/index.js + 50 modules
var esm = __webpack_require__(24436);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(13193);
// EXTERNAL MODULE: ./src/hooks/useCallWithMarketGasPrice.ts
var useCallWithMarketGasPrice = __webpack_require__(31063);
;// CONCATENATED MODULE: ./src/views/Home/Release/hook/useAddStocksToMarketplace.tsx








var useAddStocksToMarketplace = function() {
    var ref = (0,useToast/* useToast */.p)(), toastSuccess = ref.toastSuccess, toastError = ref.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var handleAddStocksToMarketplacer = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(contract, stocksAddress) {
            var tx, receipt, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPendingTx(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            callWithMarketGasPrice(contract, "addTradableStock", [
                                stocksAddress
                            ])
                        ];
                    case 2:
                        tx = _state.sent();
                        return [
                            4,
                            tx.wait()
                        ];
                    case 3:
                        receipt = _state.sent();
                        if (receipt.status) {
                            toastSuccess("Th\xeam v\xe0o whitelist th\xe0nh c\xf4ng!", /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                txHash: receipt.transactionHash
                            }));
                        } else {
                            // user rejected tx or didn't go thru
                            toastError(t("Thất bại!"), t("Đ\xe3 xảy ra lỗi, vui l\xf2ng thử lại!"));
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        console.error(e);
                        toastError(t("Thất bại!"), t("Đ\xe3 xảy ra lỗi, vui l\xf2ng thử lại!"));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setPendingTx(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(contract, stocksAddress) {
            return _ref.apply(this, arguments);
        };
    }(), [
        callWithMarketGasPrice,
        toastSuccess,
        t,
        toastError
    ]);
    return {
        handleAddStocksToMarketplacer: handleAddStocksToMarketplacer,
        pendingTx: pendingTx
    };
};

// EXTERNAL MODULE: ./src/state/home/fetchDataStocks.ts
var fetchDataStocks = __webpack_require__(71127);
;// CONCATENATED MODULE: ./src/config/constants/bytecode.js
var bytecode = "60806040523480156200001157600080fd5b5060405162006160380380620061608339818101604052810190620000379190620005d0565b856200004981620001e660201b60201c565b506000600560006101000a81548160ff0219169083151502179055506200007a6000801b33620001fb60201b60201c565b620000ac7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177533620001fb60201b60201c565b620000de7f408a36151f841709116a4e8aca4e0202874f7f54687dcb863b1ea4672dc9d8cf83620001fb60201b60201c565b8560069081620000ef91906200090a565b5084600b60006101000a81548160ff02191690831515021790555083600790816200011b91906200090a565b5082600890816200012d91906200090a565b5081600960006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555080600a81905550600d60009080600181540180825580915050600190039060005260206000200160009091909190916101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550505050505050620009f1565b8060029081620001f791906200090a565b5050565b6200020d8282620002ed60201b60201c565b620002e95760016004600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055506200028e6200035860201b60201c565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b60006004600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b600033905090565b6000604051905090565b600080fd5b600080fd5b600080fd5b600080fd5b6000601f19601f8301169050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b620003c9826200037e565b810181811067ffffffffffffffff82111715620003eb57620003ea6200038f565b5b80604052505050565b60006200040062000360565b90506200040e8282620003be565b919050565b600067ffffffffffffffff8211156200043157620004306200038f565b5b6200043c826200037e565b9050602081019050919050565b60005b83811015620004695780820151818401526020810190506200044c565b60008484015250505050565b60006200048c620004868462000413565b620003f4565b905082815260208101848484011115620004ab57620004aa62000379565b5b620004b884828562000449565b509392505050565b600082601f830112620004d857620004d762000374565b5b8151620004ea84826020860162000475565b91505092915050565b60008115159050919050565b6200050a81620004f3565b81146200051657600080fd5b50565b6000815190506200052a81620004ff565b92915050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006200055d8262000530565b9050919050565b6200056f8162000550565b81146200057b57600080fd5b50565b6000815190506200058f8162000564565b92915050565b6000819050919050565b620005aa8162000595565b8114620005b657600080fd5b50565b600081519050620005ca816200059f565b92915050565b60008060008060008060c08789031215620005f057620005ef6200036a565b5b600087015167ffffffffffffffff8111156200061157620006106200036f565b5b6200061f89828a01620004c0565b96505060206200063289828a0162000519565b955050604087015167ffffffffffffffff8111156200065657620006556200036f565b5b6200066489828a01620004c0565b945050606087015167ffffffffffffffff8111156200068857620006876200036f565b5b6200069689828a01620004c0565b9350506080620006a989828a016200057e565b92505060a0620006bc89828a01620005b9565b9150509295509295509295565b600081519050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600060028204905060018216806200071c57607f821691505b602082108103620007325762000731620006d4565b5b50919050565b60008190508160005260206000209050919050565b60006020601f8301049050919050565b600082821b905092915050565b6000600883026200079c7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff826200075d565b620007a886836200075d565b95508019841693508086168417925050509392505050565b6000819050919050565b6000620007eb620007e5620007df8462000595565b620007c0565b62000595565b9050919050565b6000819050919050565b6200080783620007ca565b6200081f6200081682620007f2565b8484546200076a565b825550505050565b600090565b6200083662000827565b62000843818484620007fc565b505050565b5b818110156200086b576200085f6000826200082c565b60018101905062000849565b5050565b601f821115620008ba57620008848162000738565b6200088f846200074d565b810160208510156200089f578190505b620008b7620008ae856200074d565b83018262000848565b50505b505050565b600082821c905092915050565b6000620008df60001984600802620008bf565b1980831691505092915050565b6000620008fa8383620008cc565b9150826002028217905092915050565b6200091582620006c9565b67ffffffffffffffff8111156200093157620009306200038f565b5b6200093d825462000703565b6200094a8282856200086f565b600060209050601f8311600181146200098257600084156200096d578287015190505b620009798582620008ec565b865550620009e9565b601f198416620009928662000738565b60005b82811015620009bc5784890151825560018201915060208501945060208101905062000995565b86831015620009dc5784890151620009d8601f891682620008cc565b8355505b6001600288020188555050505b505050505050565b61575f8062000a016000396000f3fe608060405234801561001057600080fd5b50600436106102895760003560e01c8063a22cb4651161015c578063daa17f49116100ce578063f2e83ddf11610087578063f2e83ddf146107d4578063f5ec2eed146107f2578063f698bf5914610810578063f749b60c1461081a578063f8b2cb4f1461084a578063fe0f1a4b1461087a57610289565b8063daa17f4914610712578063e985e9c514610730578063e9e9b8a814610760578063ebf2eb491461077e578063f23a6e6114610788578063f242432a146107b857610289565b8063bd1661c911610120578063bd1661c914610640578063bd85b0391461065c578063c87cbe561461068c578063d0d1a327146106aa578063d547741f146106c6578063d915673e146106e257610289565b8063a22cb465146105b0578063a7d0df0c146105cc578063ada8f919146105ea578063b51c875714610606578063bc197c811461061057610289565b80634245962b116102005780635c975abb116101b95780635c975abb146104ec57806373ad6c2d1461050a57806375b238fc1461052657806387f67d8f1461054457806391d1485414610562578063a217fddf1461059257610289565b80634245962b14610404578063447aabd2146104225780634e1273f41461043e5780634f558e791461046e5780635c2c20051461049e5780635c3184dc146104bc57610289565b8063248a9ca311610252578063248a9ca3146103465780632eb2c2d6146103765780632f2ff15d1461039257806330982cb3146103ae57806336568abe146103ca57806341ca641e146103e657610289565b8062fdd58e1461028e57806301ffc9a7146102be5780630e89341c146102ee5780631031e36e1461031e578063141a8dd814610328575b600080fd5b6102a860048036038101906102a39190613708565b610896565b6040516102b59190613757565b60405180910390f35b6102d860048036038101906102d391906137ca565b61095e565b6040516102e59190613812565b60405180910390f35b6103086004803603810190610303919061382d565b610970565b60405161031591906138ea565b60405180910390f35b610326610a04565b005b610330610a39565b60405161033d919061391b565b60405180910390f35b610360600480360381019061035b919061396c565b610a5f565b60405161036d91906139a8565b60405180910390f35b610390600480360381019061038b9190613bc0565b610a7f565b005b6103ac60048036038101906103a79190613c8f565b610b20565b005b6103c860048036038101906103c39190613708565b610b41565b005b6103e460048036038101906103df9190613c8f565b610b8f565b005b6103ee610c12565b6040516103fb9190613dcb565b60405180910390f35b61040c610d98565b60405161041991906139a8565b60405180910390f35b61043c60048036038101906104379190613eb0565b610dbc565b005b61045860048036038101906104539190613eb0565b610eb3565b6040516104659190613fd7565b60405180910390f35b6104886004803603810190610483919061382d565b610fcc565b6040516104959190613812565b60405180910390f35b6104a6610fe0565b6040516104b39190613757565b60405180910390f35b6104d660048036038101906104d1919061382d565b610fe6565b6040516104e3919061391b565b60405180910390f35b6104f4611025565b6040516105019190613812565b60405180910390f35b610524600480360381019061051f9190613ff9565b61103c565b005b61052e6110ab565b60405161053b91906139a8565b60405180910390f35b61054c6110cf565b6040516105599190614042565b60405180910390f35b61057c60048036038101906105779190613c8f565b6110d4565b6040516105899190613812565b60405180910390f35b61059a61113f565b6040516105a791906139a8565b60405180910390f35b6105ca60048036038101906105c59190614089565b611146565b005b6105d461115c565b6040516105e191906138ea565b60405180910390f35b61060460048036038101906105ff9190613ff9565b6111ea565b005b61060e61126c565b005b61062a6004803603810190610625919061417a565b6112b4565b6040516106379190614265565b60405180910390f35b61065a60048036038101906106559190613ff9565b6112cc565b005b6106766004803603810190610671919061382d565b611436565b6040516106839190613757565b60405180910390f35b610694611453565b6040516106a191906138ea565b60405180910390f35b6106c460048036038101906106bf9190614321565b6114e1565b005b6106e060048036038101906106db9190613c8f565b611518565b005b6106fc60048036038101906106f79190613ff9565b611539565b6040516107099190613757565b60405180910390f35b61071a611551565b604051610727919061391b565b60405180910390f35b61074a6004803603810190610745919061436a565b611577565b6040516107579190613812565b60405180910390f35b61076861160b565b6040516107759190614459565b60405180910390f35b610786611699565b005b6107a2600480360381019061079d919061447b565b6116ce565b6040516107af9190614265565b60405180910390f35b6107d260048036038101906107cd9190614515565b6116e4565b005b6107dc611785565b6040516107e99190613812565b60405180910390f35b6107fa611798565b60405161080791906138ea565b60405180910390f35b610818611826565b005b610834600480360381019061082f919061382d565b61186e565b604051610841919061391b565b60405180910390f35b610864600480360381019061085f9190613ff9565b6118ad565b6040516108719190613757565b60405180910390f35b610894600480360381019061088f91906145d1565b6118c4565b005b60008073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1603610906576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016108fd906146b2565b60405180910390fd5b60008083815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905092915050565b6000610969826119b4565b9050919050565b60606002805461097f90614701565b80601f01602080910402602001604051908101604052809291908181526020018280546109ab90614701565b80156109f85780601f106109cd576101008083540402835291602001916109f8565b820191906000526020600020905b8154815290600101906020018083116109db57829003601f168201915b50505050509050919050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775610a2e81611a2e565b610a36611a42565b50565b600960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600060046000838152602001908152602001600020600101549050919050565b610a87611aa5565b73ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff161480610acd5750610acc85610ac7611aa5565b611577565b5b610b0c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b03906147a4565b60405180910390fd5b610b198585858585611aad565b5050505050565b610b2982610a5f565b610b3281611a2e565b610b3c8383611dce565b505050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775610b6b81611a2e565b610b8a83600060ff168460405180602001604052806000815250611eaf565b505050565b610b97611aa5565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1614610c04576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610bfb90614836565b60405180910390fd5b610c0e828261205f565b5050565b606060006001600d80549050610c289190614885565b905060008167ffffffffffffffff811115610c4657610c456139c8565b5b604051908082528060200260200182016040528015610c7f57816020015b610c6c613630565b815260200190600190039081610c645790505b5090506000600190505b828111610d8f576000600d8281548110610ca657610ca56148b9565b5b9060005260206000200160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603610d0d5750610d7c565b6000610d18826118ad565b90506000811115610d795760405180604001604052808373ffffffffffffffffffffffffffffffffffffffff1681526020018281525084600185610d5c9190614885565b81518110610d6d57610d6c6148b9565b5b60200260200101819052505b50505b8080610d87906148e8565b915050610c89565b50809250505090565b7f408a36151f841709116a4e8aca4e0202874f7f54687dcb863b1ea4672dc9d8cf81565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775610de681611a2e565b600083519050600081118015610dfc5750825181145b610e3b576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610e32906149a2565b60405180910390fd5b60005b81811015610eac57610e99858281518110610e5c57610e5b6148b9565b5b6020026020010151600060ff16868481518110610e7c57610e7b6148b9565b5b602002602001015160405180602001604052806000815250611eaf565b8080610ea4906148e8565b915050610e3e565b5050505050565b60608151835114610ef9576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610ef090614a34565b60405180910390fd5b6000835167ffffffffffffffff811115610f1657610f156139c8565b5b604051908082528060200260200182016040528015610f445781602001602082028036833780820191505090505b50905060005b8451811015610fc157610f91858281518110610f6957610f686148b9565b5b6020026020010151858381518110610f8457610f836148b9565b5b6020026020010151610896565b828281518110610fa457610fa36148b9565b5b60200260200101818152505080610fba906148e8565b9050610f4a565b508091505092915050565b600080610fd883611436565b119050919050565b600a5481565b600d8181548110610ff657600080fd5b906000526020600020016000915054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6000600560009054906101000a900460ff16905090565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561106681611a2e565b81600b60016101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177581565b600081565b60006004600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b6000801b81565b611158611151611aa5565b8383612141565b5050565b6006805461116990614701565b80601f016020809104026020016040519081016040528092919081815260200182805461119590614701565b80156111e25780601f106111b7576101008083540402835291602001916111e2565b820191906000526020600020905b8154815290600101906020018083116111c557829003601f168201915b505050505081565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561121481611a2e565b61123e7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c217753361205f565b6112687fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177583611dce565b5050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561129681611a2e565b6001600b60006101000a81548160ff02191690831515021790555050565b600063bc197c8160e01b905098975050505050505050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c217756112f681611a2e565b6113427f408a36151f841709116a4e8aca4e0202874f7f54687dcb863b1ea4672dc9d8cf600960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1661205f565b600e600960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169080600181540180825580915050600190039060005260206000200160009091909190916101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555081600960006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055506114327f408a36151f841709116a4e8aca4e0202874f7f54687dcb863b1ea4672dc9d8cf83611dce565b5050565b600060036000838152602001908152602001600020549050919050565b6007805461146090614701565b80601f016020809104026020016040519081016040528092919081815260200182805461148c90614701565b80156114d95780601f106114ae576101008083540402835291602001916114d9565b820191906000526020600020905b8154815290600101906020018083116114bc57829003601f168201915b505050505081565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561150b81611a2e565b611514826122ad565b5050565b61152182610a5f565b61152a81611a2e565b611534838361205f565b505050565b600c6020528060005260406000206000915090505481565b600b60019054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6000600160008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b6060600e80548060200260200160405190810160405280929190818152602001828054801561168f57602002820191906000526020600020905b8160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019060010190808311611645575b5050505050905090565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c217756116c381611a2e565b6116cb6122c0565b50565b600063f23a6e6160e01b90509695505050505050565b6116ec611aa5565b73ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff16148061173257506117318561172c611aa5565b611577565b5b611771576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611768906147a4565b60405180910390fd5b61177e8585858585612323565b5050505050565b600b60009054906101000a900460ff1681565b600880546117a590614701565b80601f01602080910402602001604051908101604052809291908181526020018280546117d190614701565b801561181e5780601f106117f35761010080835404028352916020019161181e565b820191906000526020600020905b81548152906001019060200180831161180157829003601f168201915b505050505081565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561185081611a2e565b6000600b60006101000a81548160ff02191690831515021790555050565b600e818154811061187e57600080fd5b906000526020600020016000915054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60006118bd82600060ff16610896565b9050919050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c217756118ee81611a2e565b6000849050600081511461190657611905856114e1565b5b600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161461194457611943846112cc565b5b60018081111561195757611956614a54565b5b83600181111561196a57611969614a54565b5b036119785761197761126c565b5b6000600181111561198c5761198b614a54565b5b83600181111561199f5761199e614a54565b5b036119ad576119ac611826565b5b5050505050565b60007f7965db0b000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19161480611a275750611a26826125be565b5b9050919050565b611a3f81611a3a611aa5565b6126a0565b50565b611a4a612725565b6001600560006101000a81548160ff0219169083151502179055507f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258611a8e611aa5565b604051611a9b919061391b565b60405180910390a1565b600033905090565b8151835114611af1576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611ae890614af5565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff1603611b60576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611b5790614b87565b60405180910390fd5b6000611b6a611aa5565b9050611b7a81878787878761276f565b60005b8451811015611d2b576000858281518110611b9b57611b9a6148b9565b5b602002602001015190506000858381518110611bba57611bb96148b9565b5b60200260200101519050600080600084815260200190815260200160002060008b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905081811015611c5b576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611c5290614c19565b60405180910390fd5b81810360008085815260200190815260200160002060008c73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508160008085815260200190815260200160002060008b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254611d109190614c39565b9250508190555050505080611d24906148e8565b9050611b7d565b508473ffffffffffffffffffffffffffffffffffffffff168673ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff167f4a39dc06d4c0dbc64b70af90fd698a233a518aa5d07e595d983b8c0526c8f7fb8787604051611da2929190614c6d565b60405180910390a4611db881878787878761278d565b611dc68187878787876128a1565b505050505050565b611dd882826110d4565b611eab5760016004600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550611e50611aa5565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff1603611f1e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611f1590614d16565b60405180910390fd5b6000611f28611aa5565b90506000611f3585612a78565b90506000611f4285612a78565b9050611f538360008985858961276f565b8460008088815260200190815260200160002060008973ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254611fb29190614c39565b925050819055508673ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f628989604051612030929190614d36565b60405180910390a46120478360008985858961278d565b61205683600089898989612af2565b50505050505050565b61206982826110d4565b1561213d5760006004600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055506120e2611aa5565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b60405160405180910390a45b5050565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16036121af576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016121a690614dd1565b60405180910390fd5b80600160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31836040516122a09190613812565b60405180910390a3505050565b80600290816122bc9190614f9d565b5050565b6122c8612cc9565b6000600560006101000a81548160ff0219169083151502179055507f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa61230c611aa5565b604051612319919061391b565b60405180910390a1565b600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff1603612392576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161238990614b87565b60405180910390fd5b600061239c611aa5565b905060006123a985612a78565b905060006123b685612a78565b90506123c683898985858961276f565b600080600088815260200190815260200160002060008a73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205490508581101561245d576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161245490614c19565b60405180910390fd5b85810360008089815260200190815260200160002060008b73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508560008089815260200190815260200160002060008a73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282546125129190614c39565b925050819055508773ffffffffffffffffffffffffffffffffffffffff168973ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff167fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f628a8a60405161258f929190614d36565b60405180910390a46125a5848a8a86868a61278d565b6125b3848a8a8a8a8a612af2565b505050505050505050565b60007fd9b67a26000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916148061268957507f0e89341c000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916145b80612699575061269882612d12565b5b9050919050565b6126aa82826110d4565b612721576126b781612d7c565b6126c58360001c6020612da9565b6040516020016126d6929190615143565b6040516020818303038152906040526040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161271891906138ea565b60405180910390fd5b5050565b61272d611025565b1561276d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612764906151c9565b60405180910390fd5b565b612777612725565b612785868686868686612fe5565b505050505050565b612795612725565b6000600267ffffffffffffffff8111156127b2576127b16139c8565b5b6040519080825280602002602001820160405280156127e05781602001602082028036833780820191505090505b50905085816000815181106127f8576127f76148b9565b5b602002602001019073ffffffffffffffffffffffffffffffffffffffff16908173ffffffffffffffffffffffffffffffffffffffff16815250508481600181518110612847576128466148b9565b5b602002602001019073ffffffffffffffffffffffffffffffffffffffff16908173ffffffffffffffffffffffffffffffffffffffff168152505061288a816131b5565b612898878787878787613325565b50505050505050565b6128c08473ffffffffffffffffffffffffffffffffffffffff1661332d565b15612a70578373ffffffffffffffffffffffffffffffffffffffff1663bc197c8187878686866040518663ffffffff1660e01b815260040161290695949392919061523e565b6020604051808303816000875af192505050801561294257506040513d601f19601f8201168201806040525081019061293f91906152bb565b60015b6129e75761294e6152f5565b806308c379a0036129aa5750612962615317565b8061296d57506129ac565b806040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016129a191906138ea565b60405180910390fd5b505b6040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016129de90615419565b60405180910390fd5b63bc197c8160e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191614612a6e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612a65906154ab565b60405180910390fd5b505b505050505050565b60606000600167ffffffffffffffff811115612a9757612a966139c8565b5b604051908082528060200260200182016040528015612ac55781602001602082028036833780820191505090505b5090508281600081518110612add57612adc6148b9565b5b60200260200101818152505080915050919050565b612b118473ffffffffffffffffffffffffffffffffffffffff1661332d565b15612cc1578373ffffffffffffffffffffffffffffffffffffffff1663f23a6e6187878686866040518663ffffffff1660e01b8152600401612b579594939291906154cb565b6020604051808303816000875af1925050508015612b9357506040513d601f19601f82011682018060405250810190612b9091906152bb565b60015b612c3857612b9f6152f5565b806308c379a003612bfb5750612bb3615317565b80612bbe5750612bfd565b806040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612bf291906138ea565b60405180910390fd5b505b6040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612c2f90615419565b60405180910390fd5b63f23a6e6160e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191614612cbf576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612cb6906154ab565b60405180910390fd5b505b505050505050565b612cd1611025565b612d10576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612d0790615571565b60405180910390fd5b565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b6060612da28273ffffffffffffffffffffffffffffffffffffffff16601460ff16612da9565b9050919050565b606060006002836002612dbc9190615591565b612dc69190614c39565b67ffffffffffffffff811115612ddf57612dde6139c8565b5b6040519080825280601f01601f191660200182016040528015612e115781602001600182028036833780820191505090505b5090507f300000000000000000000000000000000000000000000000000000000000000081600081518110612e4957612e486148b9565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a9053507f780000000000000000000000000000000000000000000000000000000000000081600181518110612ead57612eac6148b9565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a90535060006001846002612eed9190615591565b612ef79190614c39565b90505b6001811115612f97577f3031323334353637383961626364656600000000000000000000000000000000600f861660108110612f3957612f386148b9565b5b1a60f81b828281518110612f5057612f4f6148b9565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a905350600485901c945080612f90906155d3565b9050612efa565b5060008414612fdb576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612fd290615648565b60405180910390fd5b8091505092915050565b612ff3868686868686613350565b600073ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff16036130a45760005b83518110156130a257828181518110613046576130456148b9565b5b602002602001015160036000868481518110613065576130646148b9565b5b60200260200101518152602001908152602001600020600082825461308a9190614c39565b925050819055508061309b906148e8565b905061302a565b505b600073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff16036131ad5760005b83518110156131ab5760008482815181106130f9576130f86148b9565b5b602002602001015190506000848381518110613118576131176148b9565b5b602002602001015190506000600360008481526020019081526020016000205490508181101561317d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401613174906156da565b60405180910390fd5b8181036003600085815260200190815260200160002081905550505050806131a4906148e8565b90506130db565b505b505050505050565b60005b81518110156133215760008282815181106131d6576131d56148b9565b5b60200260200101519050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff160361321f5761321c611aa5565b90505b600061322a826118ad565b111561325857613253838381518110613246576132456148b9565b5b6020026020010151613358565b61330d565b6000613263826118ad565b1480156132af57506000600c60008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054115b1561330c576000600c60008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905061330181613415565b61330a82613555565b505b5b508080613319906148e8565b9150506131b8565b5050565b505050505050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b505050505050565b6133618161359b565b61341257600d80549050600c60008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550600d819080600181540180825580915050600190039060005260206000200160009091909190916101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505b50565b6000600d6001600d8054905061342b9190614885565b8154811061343c5761343b6148b9565b5b9060005260206000200160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905080600d838154811061347e5761347d6148b9565b5b9060005260206000200160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555081600c60008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550600d80548061351c5761351b6156fa565b5b6001900381819060005260206000200160006101000a81549073ffffffffffffffffffffffffffffffffffffffff021916905590555050565b600c60008273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000905550565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415801561361857506000600c60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054115b15613626576001905061362b565b600090505b919050565b6040518060400160405280600073ffffffffffffffffffffffffffffffffffffffff168152602001600081525090565b6000604051905090565b600080fd5b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600061369f82613674565b9050919050565b6136af81613694565b81146136ba57600080fd5b50565b6000813590506136cc816136a6565b92915050565b6000819050919050565b6136e5816136d2565b81146136f057600080fd5b50565b600081359050613702816136dc565b92915050565b6000806040838503121561371f5761371e61366a565b5b600061372d858286016136bd565b925050602061373e858286016136f3565b9150509250929050565b613751816136d2565b82525050565b600060208201905061376c6000830184613748565b92915050565b60007fffffffff0000000000000000000000000000000000000000000000000000000082169050919050565b6137a781613772565b81146137b257600080fd5b50565b6000813590506137c48161379e565b92915050565b6000602082840312156137e0576137df61366a565b5b60006137ee848285016137b5565b91505092915050565b60008115159050919050565b61380c816137f7565b82525050565b60006020820190506138276000830184613803565b92915050565b6000602082840312156138435761384261366a565b5b6000613851848285016136f3565b91505092915050565b600081519050919050565b600082825260208201905092915050565b60005b83811015613894578082015181840152602081019050613879565b60008484015250505050565b6000601f19601f8301169050919050565b60006138bc8261385a565b6138c68185613865565b93506138d6818560208601613876565b6138df816138a0565b840191505092915050565b6000602082019050818103600083015261390481846138b1565b905092915050565b61391581613694565b82525050565b6000602082019050613930600083018461390c565b92915050565b6000819050919050565b61394981613936565b811461395457600080fd5b50565b60008135905061396681613940565b92915050565b6000602082840312156139825761398161366a565b5b600061399084828501613957565b91505092915050565b6139a281613936565b82525050565b60006020820190506139bd6000830184613999565b92915050565b600080fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b613a00826138a0565b810181811067ffffffffffffffff82111715613a1f57613a1e6139c8565b5b80604052505050565b6000613a32613660565b9050613a3e82826139f7565b919050565b600067ffffffffffffffff821115613a5e57613a5d6139c8565b5b602082029050602081019050919050565b600080fd5b6000613a87613a8284613a43565b613a28565b90508083825260208201905060208402830185811115613aaa57613aa9613a6f565b5b835b81811015613ad35780613abf88826136f3565b845260208401935050602081019050613aac565b5050509392505050565b600082601f830112613af257613af16139c3565b5b8135613b02848260208601613a74565b91505092915050565b600080fd5b600067ffffffffffffffff821115613b2b57613b2a6139c8565b5b613b34826138a0565b9050602081019050919050565b82818337600083830152505050565b6000613b63613b5e84613b10565b613a28565b905082815260208101848484011115613b7f57613b7e613b0b565b5b613b8a848285613b41565b509392505050565b600082601f830112613ba757613ba66139c3565b5b8135613bb7848260208601613b50565b91505092915050565b600080600080600060a08688031215613bdc57613bdb61366a565b5b6000613bea888289016136bd565b9550506020613bfb888289016136bd565b945050604086013567ffffffffffffffff811115613c1c57613c1b61366f565b5b613c2888828901613add565b935050606086013567ffffffffffffffff811115613c4957613c4861366f565b5b613c5588828901613add565b925050608086013567ffffffffffffffff811115613c7657613c7561366f565b5b613c8288828901613b92565b9150509295509295909350565b60008060408385031215613ca657613ca561366a565b5b6000613cb485828601613957565b9250506020613cc5858286016136bd565b9150509250929050565b600081519050919050565b600082825260208201905092915050565b6000819050602082019050919050565b613d0481613694565b82525050565b613d13816136d2565b82525050565b604082016000820151613d2f6000850182613cfb565b506020820151613d426020850182613d0a565b50505050565b6000613d548383613d19565b60408301905092915050565b6000602082019050919050565b6000613d7882613ccf565b613d828185613cda565b9350613d8d83613ceb565b8060005b83811015613dbe578151613da58882613d48565b9750613db083613d60565b925050600181019050613d91565b5085935050505092915050565b60006020820190508181036000830152613de58184613d6d565b905092915050565b600067ffffffffffffffff821115613e0857613e076139c8565b5b602082029050602081019050919050565b6000613e2c613e2784613ded565b613a28565b90508083825260208201905060208402830185811115613e4f57613e4e613a6f565b5b835b81811015613e785780613e6488826136bd565b845260208401935050602081019050613e51565b5050509392505050565b600082601f830112613e9757613e966139c3565b5b8135613ea7848260208601613e19565b91505092915050565b60008060408385031215613ec757613ec661366a565b5b600083013567ffffffffffffffff811115613ee557613ee461366f565b5b613ef185828601613e82565b925050602083013567ffffffffffffffff811115613f1257613f1161366f565b5b613f1e85828601613add565b9150509250929050565b600081519050919050565b600082825260208201905092915050565b6000819050602082019050919050565b6000613f608383613d0a565b60208301905092915050565b6000602082019050919050565b6000613f8482613f28565b613f8e8185613f33565b9350613f9983613f44565b8060005b83811015613fca578151613fb18882613f54565b9750613fbc83613f6c565b925050600181019050613f9d565b5085935050505092915050565b60006020820190508181036000830152613ff18184613f79565b905092915050565b60006020828403121561400f5761400e61366a565b5b600061401d848285016136bd565b91505092915050565b600060ff82169050919050565b61403c81614026565b82525050565b60006020820190506140576000830184614033565b92915050565b614066816137f7565b811461407157600080fd5b50565b6000813590506140838161405d565b92915050565b600080604083850312156140a05761409f61366a565b5b60006140ae858286016136bd565b92505060206140bf85828601614074565b9150509250929050565b600080fd5b60008083601f8401126140e4576140e36139c3565b5b8235905067ffffffffffffffff811115614101576141006140c9565b5b60208301915083602082028301111561411d5761411c613a6f565b5b9250929050565b60008083601f84011261413a576141396139c3565b5b8235905067ffffffffffffffff811115614157576141566140c9565b5b60208301915083600182028301111561417357614172613a6f565b5b9250929050565b60008060008060008060008060a0898b03121561419a5761419961366a565b5b60006141a88b828c016136bd565b98505060206141b98b828c016136bd565b975050604089013567ffffffffffffffff8111156141da576141d961366f565b5b6141e68b828c016140ce565b9650965050606089013567ffffffffffffffff8111156142095761420861366f565b5b6142158b828c016140ce565b9450945050608089013567ffffffffffffffff8111156142385761423761366f565b5b6142448b828c01614124565b92509250509295985092959890939650565b61425f81613772565b82525050565b600060208201905061427a6000830184614256565b92915050565b600067ffffffffffffffff82111561429b5761429a6139c8565b5b6142a4826138a0565b9050602081019050919050565b60006142c46142bf84614280565b613a28565b9050828152602081018484840111156142e0576142df613b0b565b5b6142eb848285613b41565b509392505050565b600082601f830112614308576143076139c3565b5b81356143188482602086016142b1565b91505092915050565b6000602082840312156143375761433661366a565b5b600082013567ffffffffffffffff8111156143555761435461366f565b5b614361848285016142f3565b91505092915050565b600080604083850312156143815761438061366a565b5b600061438f858286016136bd565b92505060206143a0858286016136bd565b9150509250929050565b600081519050919050565b600082825260208201905092915050565b6000819050602082019050919050565b60006143e28383613cfb565b60208301905092915050565b6000602082019050919050565b6000614406826143aa565b61441081856143b5565b935061441b836143c6565b8060005b8381101561444c57815161443388826143d6565b975061443e836143ee565b92505060018101905061441f565b5085935050505092915050565b6000602082019050818103600083015261447381846143fb565b905092915050565b60008060008060008060a087890312156144985761449761366a565b5b60006144a689828a016136bd565b96505060206144b789828a016136bd565b95505060406144c889828a016136f3565b94505060606144d989828a016136f3565b935050608087013567ffffffffffffffff8111156144fa576144f961366f565b5b61450689828a01614124565b92509250509295509295509295565b600080600080600060a086880312156145315761453061366a565b5b600061453f888289016136bd565b9550506020614550888289016136bd565b9450506040614561888289016136f3565b9350506060614572888289016136f3565b925050608086013567ffffffffffffffff8111156145935761459261366f565b5b61459f88828901613b92565b9150509295509295909350565b600281106145b957600080fd5b50565b6000813590506145cb816145ac565b92915050565b6000806000606084860312156145ea576145e961366a565b5b600084013567ffffffffffffffff8111156146085761460761366f565b5b614614868287016142f3565b9350506020614625868287016136bd565b9250506040614636868287016145bc565b9150509250925092565b7f455243313135353a2061646472657373207a65726f206973206e6f742061207660008201527f616c6964206f776e657200000000000000000000000000000000000000000000602082015250565b600061469c602a83613865565b91506146a782614640565b604082019050919050565b600060208201905081810360008301526146cb8161468f565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b6000600282049050600182168061471957607f821691505b60208210810361472c5761472b6146d2565b5b50919050565b7f455243313135353a2063616c6c6572206973206e6f7420746f6b656e206f776e60008201527f6572206f7220617070726f766564000000000000000000000000000000000000602082015250565b600061478e602e83613865565b915061479982614732565b604082019050919050565b600060208201905081810360008301526147bd81614781565b9050919050565b7f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560008201527f20726f6c657320666f722073656c660000000000000000000000000000000000602082015250565b6000614820602f83613865565b915061482b826147c4565b604082019050919050565b6000602082019050818103600083015261484f81614813565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000614890826136d2565b915061489b836136d2565b92508282039050818111156148b3576148b2614856565b5b92915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60006148f3826136d2565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff820361492557614924614856565b5b600182019050919050565b7f607368617265686f6c646572736020616e642060616d6f756e747360206d757360008201527f742068617665207468652073616d65206c656e6774682e000000000000000000602082015250565b600061498c603783613865565b915061499782614930565b604082019050919050565b600060208201905081810360008301526149bb8161497f565b9050919050565b7f455243313135353a206163636f756e747320616e6420696473206c656e67746860008201527f206d69736d617463680000000000000000000000000000000000000000000000602082015250565b6000614a1e602983613865565b9150614a29826149c2565b604082019050919050565b60006020820190508181036000830152614a4d81614a11565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b7f455243313135353a2069647320616e6420616d6f756e7473206c656e6774682060008201527f6d69736d61746368000000000000000000000000000000000000000000000000602082015250565b6000614adf602883613865565b9150614aea82614a83565b604082019050919050565b60006020820190508181036000830152614b0e81614ad2565b9050919050565b7f455243313135353a207472616e7366657220746f20746865207a65726f20616460008201527f6472657373000000000000000000000000000000000000000000000000000000602082015250565b6000614b71602583613865565b9150614b7c82614b15565b604082019050919050565b60006020820190508181036000830152614ba081614b64565b9050919050565b7f455243313135353a20696e73756666696369656e742062616c616e636520666f60008201527f72207472616e7366657200000000000000000000000000000000000000000000602082015250565b6000614c03602a83613865565b9150614c0e82614ba7565b604082019050919050565b60006020820190508181036000830152614c3281614bf6565b9050919050565b6000614c44826136d2565b9150614c4f836136d2565b9250828201905080821115614c6757614c66614856565b5b92915050565b60006040820190508181036000830152614c878185613f79565b90508181036020830152614c9b8184613f79565b90509392505050565b7f455243313135353a206d696e7420746f20746865207a65726f2061646472657360008201527f7300000000000000000000000000000000000000000000000000000000000000602082015250565b6000614d00602183613865565b9150614d0b82614ca4565b604082019050919050565b60006020820190508181036000830152614d2f81614cf3565b9050919050565b6000604082019050614d4b6000830185613748565b614d586020830184613748565b9392505050565b7f455243313135353a2073657474696e6720617070726f76616c2073746174757360008201527f20666f722073656c660000000000000000000000000000000000000000000000602082015250565b6000614dbb602983613865565b9150614dc682614d5f565b604082019050919050565b60006020820190508181036000830152614dea81614dae565b9050919050565b60008190508160005260206000209050919050565b60006020601f8301049050919050565b600082821b905092915050565b600060088302614e537fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82614e16565b614e5d8683614e16565b95508019841693508086168417925050509392505050565b6000819050919050565b6000614e9a614e95614e90846136d2565b614e75565b6136d2565b9050919050565b6000819050919050565b614eb483614e7f565b614ec8614ec082614ea1565b848454614e23565b825550505050565b600090565b614edd614ed0565b614ee8818484614eab565b505050565b5b81811015614f0c57614f01600082614ed5565b600181019050614eee565b5050565b601f821115614f5157614f2281614df1565b614f2b84614e06565b81016020851015614f3a578190505b614f4e614f4685614e06565b830182614eed565b50505b505050565b600082821c905092915050565b6000614f7460001984600802614f56565b1980831691505092915050565b6000614f8d8383614f63565b9150826002028217905092915050565b614fa68261385a565b67ffffffffffffffff811115614fbf57614fbe6139c8565b5b614fc98254614701565b614fd4828285614f10565b600060209050601f8311600181146150075760008415614ff5578287015190505b614fff8582614f81565b865550615067565b601f19841661501586614df1565b60005b8281101561503d57848901518255600182019150602085019450602081019050615018565b8683101561505a5784890151615056601f891682614f63565b8355505b6001600288020188555050505b505050505050565b600081905092915050565b7f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000600082015250565b60006150b060178361506f565b91506150bb8261507a565b601782019050919050565b60006150d18261385a565b6150db818561506f565b93506150eb818560208601613876565b80840191505092915050565b7f206973206d697373696e6720726f6c6520000000000000000000000000000000600082015250565b600061512d60118361506f565b9150615138826150f7565b601182019050919050565b600061514e826150a3565b915061515a82856150c6565b915061516582615120565b915061517182846150c6565b91508190509392505050565b7f5061757361626c653a2070617573656400000000000000000000000000000000600082015250565b60006151b3601083613865565b91506151be8261517d565b602082019050919050565b600060208201905081810360008301526151e2816151a6565b9050919050565b600081519050919050565b600082825260208201905092915050565b6000615210826151e9565b61521a81856151f4565b935061522a818560208601613876565b615233816138a0565b840191505092915050565b600060a082019050615253600083018861390c565b615260602083018761390c565b81810360408301526152728186613f79565b905081810360608301526152868185613f79565b9050818103608083015261529a8184615205565b90509695505050505050565b6000815190506152b58161379e565b92915050565b6000602082840312156152d1576152d061366a565b5b60006152df848285016152a6565b91505092915050565b60008160e01c9050919050565b600060033d11156153145760046000803e6153116000516152e8565b90505b90565b600060443d106153a457615329613660565b60043d036004823e80513d602482011167ffffffffffffffff821117156153515750506153a4565b808201805167ffffffffffffffff81111561536f57505050506153a4565b80602083010160043d03850181111561538c5750505050506153a4565b61539b826020018501866139f7565b82955050505050505b90565b7f455243313135353a207472616e7366657220746f206e6f6e2d4552433131353560008201527f526563656976657220696d706c656d656e746572000000000000000000000000602082015250565b6000615403603483613865565b915061540e826153a7565b604082019050919050565b60006020820190508181036000830152615432816153f6565b9050919050565b7f455243313135353a204552433131353552656365697665722072656a6563746560008201527f6420746f6b656e73000000000000000000000000000000000000000000000000602082015250565b6000615495602883613865565b91506154a082615439565b604082019050919050565b600060208201905081810360008301526154c481615488565b9050919050565b600060a0820190506154e0600083018861390c565b6154ed602083018761390c565b6154fa6040830186613748565b6155076060830185613748565b81810360808301526155198184615205565b90509695505050505050565b7f5061757361626c653a206e6f7420706175736564000000000000000000000000600082015250565b600061555b601483613865565b915061556682615525565b602082019050919050565b6000602082019050818103600083015261558a8161554e565b9050919050565b600061559c826136d2565b91506155a7836136d2565b92508282026155b5816136d2565b915082820484148315176155cc576155cb614856565b5b5092915050565b60006155de826136d2565b9150600082036155f1576155f0614856565b5b600182039050919050565b7f537472696e67733a20686578206c656e67746820696e73756666696369656e74600082015250565b6000615632602083613865565b915061563d826155fc565b602082019050919050565b6000602082019050818103600083015261566181615625565b9050919050565b7f455243313135353a206275726e20616d6f756e74206578636565647320746f7460008201527f616c537570706c79000000000000000000000000000000000000000000000000602082015250565b60006156c4602883613865565b91506156cf82615668565b604082019050919050565b600060208201905081810360008301526156f3816156b7565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603160045260246000fdfea2646970667358221220911ad88413b2f4de29222fd1dd504a61338c86f7fee0202414aad8a292b82a6364736f6c63430008120033";

// EXTERNAL MODULE: ./src/config/abi/stocks.json
var stocks = __webpack_require__(15497);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./src/config/constants/stocks/97.ts
var _97 = __webpack_require__(51948);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/views/Edit/UploadImageMobile.tsx
var UploadImageMobile = __webpack_require__(2551);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/antd/lib/index.js
var antd_lib = __webpack_require__(69215);
// EXTERNAL MODULE: ./src/views/Edit/UploadImage.tsx
var UploadImage = __webpack_require__(9183);
// EXTERNAL MODULE: ./src/views/Home/components/style.ts
var style = __webpack_require__(44331);
;// CONCATENATED MODULE: ./src/views/Home/Release/index.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    outline: none;\n    font-size: 16px;\n    border-radius: 12px;\n    height:56px;\n    border: ",
        ";\n    background: var(--neutral-00, #FFF);\n    &:focus-visible {\n        outline: none;  \n        border: ",
        ";\n    }\n    ::placeholder {\n        color:",
        ";\n        opacity: 1;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    border-radius: 12px;\n    color: ",
        ";\n    display: block;\n    font-size: 14px;\n    outline: 0;\n    padding: 0 16px;\n    height:56px;\n    width: 100%;\n    border: ",
        ";\n    background: var(--neutral-00, #FFF);\n    &::placeholder {\n        color: ",
        ";\n    }\n    &:focus-visible {\n        outline: none;\n        border: 2px solid rgba(53, 93, 255, 0.35);\n    }\n    &:disabled {\n        background-color: ",
        ";\n        box-shadow: none;\n        color: ",
        ";\n        cursor: not-allowed;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .ant-radio-inner{\n        width:24px;\n        height:24px;\n        border-color: #000000 !important ;\n        background-color:transparent !important;\n    }\n    .ant-radio-checked .ant-radio-inner {\n        border-color: #355DFF !important ;\n        border-width:6px;\n      }\n    .ant-radio-checked {\n        background-color: transparent !important;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
































var Release = function(param) {
    var releaseType = param.releaseType, isOwnerMarketplace = param.isOwnerMarketplace;
    var displayTooltipCode = function displayTooltipCode() {
        setIsTooltipDisplayed(true);
        setTimeout(function() {
            setIsTooltipDisplayed(false);
        }, 3000);
    };
    var ref, ref1, ref2, ref3, ref4;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref5 = (0,useActiveWeb3React/* default */.Z)(), chainId = ref5.chainId, account = ref5.account;
    var ref6 = (0,react.useState)(""), fillCidLink = ref6[0], setFillCidLink = ref6[1];
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref7 = (0,dist/* useSigner */.mx)(), signer = ref7.data;
    var ref8 = (0,useToast/* useToast */.p)(), toastError = ref8.toastError, toastSuccess = ref8.toastSuccess;
    var ref9 = (0,react.useState)(false), isTooltipDisplayed = ref9[0], setIsTooltipDisplayed = ref9[1];
    var handleRejected = useUserRejected().handleRejected;
    var ref10 = (0,react.useState)(false), pendingDeploy = ref10[0], setPendingDeploy = ref10[1];
    var ref11 = (0,react.useState)(""), contractAddress = ref11[0], setContractAddress = ref11[1];
    var marketplaceAddress = (0,addressHelpers/* getAddress */.Kn)(contracts/* default */.Z === null || contracts/* default */.Z === void 0 ? void 0 : contracts/* default.marketplace */.Z.marketplace, chainId);
    var contract = (0,useContract/* useContractMarketplace */._i)(marketplaceAddress);
    var ref12 = (0,react.useState)(0), currenTime = ref12[0], setCurrentTime = ref12[1];
    var ref13 = useAddStocksToMarketplace(), handleAddStocksToMarketplacer = ref13.handleAddStocksToMarketplacer, pendingTx = ref13.pendingTx;
    var isWhitelist = (0,fetchDataStocks/* getDataStocksOnWhitelist */.Co)(contractAddress, marketplaceAddress, chainId, currenTime).isWhitelist;
    var ref14 = (0,react.useState)(false), errorImg = ref14[0], setErrorImg = ref14[1];
    var handleAddWhitelist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleAddStocksToMarketplacer(contract, contractAddress)
                        ];
                    case 1:
                        _state.sent();
                        setCurrentTime(Date.now());
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddWhitelist() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCoppy = function(address) {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(address).then(function() {
                return displayTooltipCode();
            });
        } else if (document.queryCommandSupported("copy")) {
            var ele = document.createElement("textarea");
            ele.value = address;
            document.body.appendChild(ele);
            ele.select();
            document.execCommand("copy");
            document.body.removeChild(ele);
            displayTooltipCode();
        }
    };
    var isExist = function(code) {
        var exist = _97["default"].filter(function(item) {
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.symbol.toString()) === code;
        });
        return exist.length === 0;
    };
    var isAddressValid = function(walletAddress) {
        return walletAddress.length > 0 && (0,esm/* isAddress */.UJ)(walletAddress);
    };
    var validationSchema = yup_index_esm/* object */.Ry().shape({
        code: yup_index_esm/* string */.Z_().required("Vui l\xf2ng nhập m\xe3 cổ phiếu").test("type", "M\xe3 cổ phiếu đ\xe3 tồn tại", isExist),
        companyName: yup_index_esm/* string */.Z_().required("Vui l\xf2ng nhập t\xean c\xf4ng ty"),
        walletAddress: yup_index_esm/* string */.Z_().required("Vui l\xf2ng nhập địa chỉ v\xed").test("type", "Địa chỉ v\xed kh\xf4ng hợp lệ", isAddressValid),
        price: yup_index_esm/* string */.Z_().required("Vui l\xf2ng nhập mệnh gi\xe1"),
        radio: yup_index_esm/* number */.Rx()
    });
    (0,react.useEffect)(function() {
        setValue("code", "");
        setValue("companyName", "");
        setValue("walletAddress", "");
        setValue("price", "");
        setValue("radio", 0);
        setFillCidLink("");
        setContractAddress("");
    }, []);
    var ref15 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        resolver: (0,yup/* yupResolver */.X)(validationSchema)
    }), register = ref15.register, reset = ref15.reset, resetField = ref15.resetField, handleSubmit = ref15.handleSubmit, errors = ref15.formState.errors, control = ref15.control, getValues = ref15.getValues, setValue = ref15.setValue, watch = ref15.watch;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var factory, contract, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("Data release submit", fillCidLink, Number(data === null || data === void 0 ? void 0 : data.radio) === 1 ? true : false, data === null || data === void 0 ? void 0 : data.code, data === null || data === void 0 ? void 0 : data.companyName, data === null || data === void 0 ? void 0 : data.walletAddress, Number(data === null || data === void 0 ? void 0 : data.price.replace(/,/g, "")));
                        setPendingDeploy(!false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        factory = new lib_esm/* ContractFactory */.lV(stocks, bytecode, signer);
                        return [
                            4,
                            factory.deploy(fillCidLink, Number(data === null || data === void 0 ? void 0 : data.radio) === 1 ? true : false, data === null || data === void 0 ? void 0 : data.code, data === null || data === void 0 ? void 0 : data.companyName, data === null || data === void 0 ? void 0 : data.walletAddress, Number(data === null || data === void 0 ? void 0 : data.price.replace(/,/g, "")))
                        ];
                    case 2:
                        contract = _state.sent();
                        return [
                            4,
                            contract.deployed()
                        ];
                    case 3:
                        _state.sent();
                        setContractAddress(contract === null || contract === void 0 ? void 0 : contract.address);
                        toastSuccess("Ph\xe1t h\xe0nh th\xe0nh c\xf4ng", /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: "#777E90",
                                                fontWeight: 700
                                            },
                                            children: "M\xe3 cổ phiếu: "
                                        }),
                                        data === null || data === void 0 ? void 0 : data.code
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                    txHash: contract === null || contract === void 0 ? void 0 : contract.deployTransaction.hash
                                })
                            ]
                        }));
                        reset();
                        setValue("code", "");
                        setValue("companyName", "");
                        setValue("walletAddress", "");
                        setValue("price", "");
                        setValue("radio", 0);
                        setFillCidLink("");
                        setFillCidLink("");
                        dispatch((0,actions/* fetchReleaseType */.l)({
                            releaseType: home/* ReleaseType.AUTO */.AI.AUTO
                        }));
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        handleRejected(e);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setPendingDeploy(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchReleaseType */.l)({
            releaseType: home/* ReleaseType.AUTO */.AI.AUTO
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "100%",
        padding: [
            "0.5rem",
            ,
            ,
            "2rem"
        ],
        flexDirection: "column",
        style: {
            gap: "1rem",
            borderRadius: "20px",
            backgroundColor: "#F8F8F8"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            style: {
                width: "100%",
                display: "flex"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                style: {
                    gap: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "100%",
                        flexDirection: [
                            "column",
                            "column",
                            "row",
                            "row"
                        ],
                        style: {
                            gap: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: [
                                    "100%",
                                    "100%",
                                    "100%",
                                    "50%"
                                ],
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                style: {
                                    gap: "1rem"
                                },
                                children: lib/* isDesktop */.nI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                                    handleCidLink: function(newCidLink) {
                                        return setFillCidLink(newCidLink);
                                    },
                                    defaultImage: "",
                                    cidLink: fillCidLink,
                                    errorImg: errorImg,
                                    handleErrorImg: function(newError) {
                                        return setErrorImg(newError);
                                    },
                                    deleteImg: null,
                                    handleDelete: null
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImageMobile/* default */.Z, {})
                            }),
                            lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                style: {
                                    gap: "12px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "var(--neutral-05, #33383F);",
                                        bold: true,
                                        fontSize: "18px",
                                        children: "M\xe3 cổ phiếu"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        borderRadius: "12px",
                                        height: "100%",
                                        alignItems: "flex-start",
                                        flexDirection: "column",
                                        style: {
                                            gap: "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                control: control,
                                                name: "code",
                                                render: function(param) {
                                                    var field = param.field;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInputFormat, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                        placeholder: "Nhập m\xe3 cổ phiếu",
                                                        isError: errors.code ? true : false,
                                                        onFocus: function() {
                                                            return setErrorImg(false);
                                                        }
                                                    }));
                                                }
                                            }),
                                            errors.code && errors.code.type === "validate" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "red",
                                                children: "M\xe3 cổ phiếu đ\xe3 tồn tại"
                                            }),
                                            errors.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "red",
                                                children: errors.code.message.toString()
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: [
                                    "100%",
                                    "100%",
                                    "100%",
                                    "50%"
                                ],
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                style: {
                                    gap: "1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        style: {
                                            gap: "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "var(--neutral-05, #33383F);",
                                                fontSize: "18px",
                                                children: "T\xean c\xf4ng ty"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                width: "100%",
                                                justifyContent: "space-between",
                                                borderRadius: "12px",
                                                height: "100%",
                                                alignItems: "flex-start",
                                                flexDirection: "column",
                                                style: {
                                                    gap: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                        control: control,
                                                        name: "companyName",
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInputFormat, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                                placeholder: "Nhập t\xean c\xf4ng ty",
                                                                isError: errors.companyName ? true : false,
                                                                onFocus: function() {
                                                                    return setErrorImg(false);
                                                                }
                                                            }));
                                                        }
                                                    }),
                                                    errors.companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "red",
                                                        children: errors.companyName.message
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        style: {
                                            gap: "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "var(--neutral-05, #33383F);",
                                                fontSize: "18px",
                                                children: "Địa chỉ v\xed"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                width: "100%",
                                                justifyContent: "space-between",
                                                borderRadius: "12px",
                                                height: "100%",
                                                alignItems: "flex-start",
                                                flexDirection: "column",
                                                style: {
                                                    gap: "12px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                        control: control,
                                                        name: "walletAddress",
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                                    text: field.value,
                                                                    tooltipMessage: "Coppied",
                                                                    tooltipRight: 40,
                                                                    tooltipTop: 0
                                                                }),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInputFormat, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                                    placeholder: "Nhập địa chỉ v\xed",
                                                                    isError: errors.walletAddress ? true : false,
                                                                    onFocus: function() {
                                                                        return setErrorImg(false);
                                                                    }
                                                                }))
                                                            });
                                                        }
                                                    }),
                                                    errors.walletAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "red",
                                                        children: errors.walletAddress.message.toString()
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "100%",
                        flexDirection: [
                            "column",
                            "column",
                            "row",
                            "row"
                        ],
                        style: {
                            gap: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: [
                                    "100%",
                                    "100%",
                                    "100%",
                                    "50%"
                                ],
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                style: {
                                    gap: "1.5rem"
                                },
                                children: lib/* isDesktop */.nI && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    width: "100%",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    style: {
                                        gap: "12px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "var(--neutral-05, #33383F);",
                                            bold: true,
                                            fontSize: "18px",
                                            children: "M\xe3 cổ phiếu"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: "100%",
                                            justifyContent: "space-between",
                                            borderRadius: "12px",
                                            height: "100%",
                                            alignItems: "flex-start",
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                    control: control,
                                                    name: "code",
                                                    render: function(param) {
                                                        var field = param.field;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInputFormat, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                            placeholder: "Nhập m\xe3 cổ phiếu",
                                                            isError: errors.code ? true : false,
                                                            onFocus: function() {
                                                                return setErrorImg(false);
                                                            }
                                                        }));
                                                    }
                                                }),
                                                errors.code && errors.code.type === "validate" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "red",
                                                    children: "M\xe3 cổ phiếu đ\xe3 tồn tại"
                                                }),
                                                errors.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "red",
                                                    children: errors.code.message.toString()
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: [
                                    "100%",
                                    "100%",
                                    "100%",
                                    "50%"
                                ],
                                height: "100%",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                style: {
                                    gap: "1.5rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    width: "100%",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    style: {
                                        gap: "12px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            color: "var(--neutral-05, #33383F);",
                                            fontSize: "18px",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            width: "100%",
                                            justifyContent: "space-between",
                                            borderRadius: "12px",
                                            height: "100%",
                                            alignItems: "flex-start",
                                            flexDirection: "column",
                                            style: {
                                                gap: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                                                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        padding: "8px 16px 6px 16px",
                                                        background: theme.colors.green,
                                                        borderRadius: "6px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "white",
                                                            children: "VND"
                                                        })
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                        control: control,
                                                        name: "price",
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                                decimalScale: 0,
                                                                allowNegative: false,
                                                                allowLeadingZeros: false,
                                                                thousandSeparator: !false,
                                                                placeholder: "0",
                                                                isError: errors.price ? true : false,
                                                                onFocus: function() {
                                                                    return setErrorImg(false);
                                                                }
                                                            }));
                                                        }
                                                    })
                                                }),
                                                errors.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "red",
                                                    children: errors.price.message.toString()
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "flex-start",
                        height: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "var(--neutral-05, #33383F);",
                                fontSize: "18px",
                                children: "H\xecnh thức ph\xea duyệt"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "2rem"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    style: {
                                        gap: "1rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        name: "radio",
                                        control: control,
                                        defaultValue: 0,
                                        render: function(param) {
                                            var field = param.field;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsRadio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                onFocus: function() {
                                                    return setErrorImg(false);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_lib/* Radio */.Y8, {
                                                        value: home/* ReleaseType.AUTO */.AI.AUTO,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "14px",
                                                            bold: true,
                                                            children: "Tự động"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(antd_lib/* Radio */.Y8, {
                                                        value: home/* ReleaseType.BYHAND */.AI.BYHAND,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "14px",
                                                            bold: true,
                                                            children: "Thủ c\xf4ng"
                                                        })
                                                    })
                                                ]
                                            }));
                                        }
                                    })
                                })
                            }),
                            (contractAddress === null || contractAddress === void 0 ? void 0 : contractAddress.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    style: {
                                        gap: "14px"
                                    },
                                    alignItems: "center",
                                    width: [
                                        "100%",
                                        ,
                                        "600px"
                                    ],
                                    justifyContent: [
                                        "space-between",
                                        ,
                                        "flex-start"
                                    ],
                                    flexWrap: "wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#9395A4",
                                            children: "Đ\xe3 ph\xe1t h\xe0nh"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            children: contractAddress
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return handleCoppy(contractAddress);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Tooltip */.u, {
                                            isTooltipDisplayed: isTooltipDisplayed,
                                            children: "Copied"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                padding: "0 12px",
                                width: [
                                    "100%",
                                    ,
                                    "200px"
                                ],
                                disabled: pendingDeploy || ((ref = watch("code")) === null || ref === void 0 ? void 0 : ref.length) === 0 || ((ref1 = watch("companyName")) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 || ((ref2 = watch("walletAddress")) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 || ((ref3 = watch("price")) === null || ref3 === void 0 ? void 0 : ref3.length) === 0 || ((ref4 = Object.keys(errors)) === null || ref4 === void 0 ? void 0 : ref4.length) > 0,
                                endIcon: pendingDeploy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "#9395A4"
                                }) : "",
                                children: "Ph\xe1t h\xe0nh"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Home_Release = (Release);
var CsInputFormat = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-f02298a9-0"
})(_templateObject(), function(param) {
    var isError = param.isError;
    return isError ? "2px solid red" : "2px solid #E1E8E5";
}, function(param) {
    var isError = param.isError;
    return isError ? "2px solid red" : "2px solid rgba(53, 93, 255, 0.35)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-f02298a9-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var isError = param.isError;
    return isError ? "2px solid red" : "2px solid #E1E8E5";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var CsRadio = (0,styled_components_browser_esm/* default */.ZP)(antd_lib/* Radio.Group */.Y8.Group).withConfig({
    componentId: "sc-f02298a9-2"
})(_templateObject2());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(51998);
// EXTERNAL MODULE: ./src/components/Paginate/index.tsx
var Paginate = __webpack_require__(48595);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(10759);
// EXTERNAL MODULE: ./src/icons/index.ts + 11 modules
var icons = __webpack_require__(62729);
;// CONCATENATED MODULE: ./src/views/Home/components/TextWithTooltip.tsx




var TextWithTooltip = function(param) {
    var title = param.title, tooltipText = param.tooltipText;
    var ref = (0,useTooltip/* default */.Z)(tooltipText, {
        placement: "top"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        style: {
            gap: "12px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconWarning */.FC, {})
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var components_TextWithTooltip = (TextWithTooltip);

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/CheckboxV2.tsx
var CheckboxV2 = __webpack_require__(54379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Download.tsx
var Download = __webpack_require__(76429);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Search.tsx
var Search = __webpack_require__(19881);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(94974);
;// CONCATENATED MODULE: ./src/components/Select/Select.tsx




function Select_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 12px;\n    transition: border-radius 0.15s;\n"
    ]);
    Select_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Select_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    max-height: 250px;\n    padding: 12px;\n    position: absolute;\n    overflow-y: hidden;\n    overflow-x: hidden;\n    z-index: ",
        ";\n    transition: transform 0.15s, opacity 0.15s;\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 0;\n    box-sizing: border-box;\n    border-radius: 12px;\n    box-shadow: 0px 4px 18px 0px rgba(75, 75, 75, 0.08);\n"
    ]);
    Select_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Select_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        " {\n                height: auto;\n                transform: scaleY(1);\n                opacity: 1;\n                border-top-width: 2;\n                box-shadow: 0px 4px 18px 0px rgba(75, 75, 75, 0.08);\n                width: 100%;\n                background: ",
        ";\n                top: 49px;\n            }\n        "
    ]);
    Select_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    height: 48px;\n    box-sizing: border-box;\n    background: ",
        ";\n    box-shadow: 0px 4px 18px 0px rgba(75, 75, 75, 0.08);\n    border-radius: 12px;\n    border: 2px solid\n        ",
        ";\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    list-style: none;\n    padding: 8px 16px;\n    border-radius: 0px;\n    &:hover {\n        > div {\n            color: ",
        ";\n            font-weight: bold;\n        }\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (max-width: 600px) {\n        padding: 6px 0px;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3f820e-0"
})(Select_templateObject());
var DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3f820e-1"
})(Select_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3f820e-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var isActiveBorder = param.isActiveBorder, theme = param.theme;
    return isActiveBorder ? theme.colors.primary : theme.colors.cardBorder;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(Select_templateObject2(), DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.background;
    });
});
var DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-9a3f820e-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-9a3f820e-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, defaultOptionIndex = _param.defaultOptionIndex, placeHolderText = _param.placeHolderText, startIcon = _param.startIcon, isActiveBorder = _param.isActiveBorder, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText",
        "startIcon",
        "isActiveBorder"
    ]);
    var ref;
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(false), optionSelected = ref2[0], setOptionSelected = ref2[1];
    var ref3 = (0,react.useState)(defaultOptionIndex), selectedOptionIndex = ref3[0], setSelectedOptionIndex = ref3[1];
    var ref4 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref4[0], setContainerSize = ref4[1];
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toggling = function(event) {
        if (options.length > 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (defaultOptionIndex) {
            // setSelectedOptionIndex(defaultOptionIndex - 1)
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        isActiveBorder: isActiveBorder,
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownHeader, {
                onClick: toggling,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        alignItems: "center",
                        children: [
                            startIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "auto",
                                children: startIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "8px",
                                fontSize: [
                                    ,
                                    ,
                                    "14px",
                                    "16px"
                                ],
                                color: !optionSelected && placeHolderText ? "text" : undefined,
                                children: !optionSelected && placeHolderText ? placeHolderText : (ref = options[selectedOptionIndex]) === null || ref === void 0 ? void 0 : ref.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {
                        color: "text",
                        onClick: toggling,
                        style: {
                            transform: isOpen ? "rotate(90deg)" : "rotate(270deg)"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownList, {
                    ref: dropdownRef,
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                bold: selectedOptionIndex === index ? !false : false,
                                color: selectedOptionIndex === index ? "primary" : "text",
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Select_Select = (Select);
var CustomListItem = (0,styled_components_browser_esm/* default */.ZP)(ListItem).withConfig({
    componentId: "sc-9a3f820e-5"
})(_templateObject6());

// EXTERNAL MODULE: ./node_modules/react-csv/index.js
var react_csv = __webpack_require__(83461);
// EXTERNAL MODULE: ./src/utils/formatNumber.ts
var formatNumber = __webpack_require__(20012);
// EXTERNAL MODULE: ./src/utils/renderDate.ts
var renderDate = __webpack_require__(44293);
;// CONCATENATED MODULE: ./src/views/Home/Manage/Filter.tsx











var Filter = function(param) {
    var tradingType = param.tradingType, handleChangeQuery = param.handleChangeQuery, searchQuery = param.searchQuery, manegeTempConfig = param.manegeTempConfig;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isTablet = ref.isTablet, isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var handleChangeSelect = function(newSelected) {
        dispatch((0,actions/* fetchTradingType */.hN)({
            tradingType: newSelected.value
        }));
    };
    var handleChangeSearchQuery = function(event) {
        var re = /[0-9a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|_]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
            var values = event.target.value;
            var replace = values.replace(/[.><,'":;/*+?^${}()|[\]\\!@#%&_~]/g, "");
            handleChangeQuery(replace);
        }
    };
    var headers = [
        {
            label: "STT",
            key: "index"
        },
        {
            label: "M\xe3 cổ phiếu",
            key: "symbol"
        },
        {
            label: "T\xean c\xf4ng ty",
            key: "companyName"
        },
        {
            label: "Mệnh gi\xe1",
            key: "issuePrice"
        },
        {
            label: "Địa chỉ v\xed ph\xea duyệt",
            key: "approveWallet"
        },
        {
            label: "Tổng số lượng ph\xe1t h\xe0nh",
            key: "totalReleaseStocks"
        },
        {
            label: "Tổng gi\xe1 trị cổ phiếu",
            key: "totalValueOfStocks"
        }, 
    ];
    var dataCsv = (0,react.useMemo)(function() {
        return manegeTempConfig === null || manegeTempConfig === void 0 ? void 0 : manegeTempConfig.map(function(dt, index) {
            return {
                index: index + 1,
                symbol: dt === null || dt === void 0 ? void 0 : dt.symbol,
                companyName: dt === null || dt === void 0 ? void 0 : dt.companyName,
                issuePrice: (0,formatNumber/* formatNumber */.u)(dt === null || dt === void 0 ? void 0 : dt.issuePrice),
                approveWallet: dt === null || dt === void 0 ? void 0 : dt.approveWallet,
                totalReleaseStocks: (0,formatNumber/* formatNumber */.u)(dt === null || dt === void 0 ? void 0 : dt.totalReleaseStocks),
                totalValueOfStocks: (0,formatNumber/* formatNumber */.u)(dt === null || dt === void 0 ? void 0 : dt.totalValueOfStocks)
            };
        });
    }, [
        manegeTempConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        justifyContent: "space-between",
        mt: "2rem",
        alignItems: "flex-end",
        flexWrap: "wrap",
        style: {
            gap: "1rem"
        },
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                style: {
                    gap: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                checked: tradingType === home/* TradeType.ALL */.YL.ALL,
                                scale: "sm",
                                onClick: function() {
                                    dispatch((0,actions/* fetchTradingType */.hN)({
                                        tradingType: home/* TradeType.ALL */.YL.ALL
                                    }));
                                    dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
                                        pageActiveManage: 0
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                bold: true,
                                children: "Tất cả"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                checked: tradingType === home/* TradeType.STOPTRANSACTION */.YL.STOPTRANSACTION,
                                scale: "sm",
                                onClick: function() {
                                    dispatch((0,actions/* fetchTradingType */.hN)({
                                        tradingType: home/* TradeType.STOPTRANSACTION */.YL.STOPTRANSACTION
                                    }));
                                    dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
                                        pageActiveManage: 0
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                bold: true,
                                children: "Ngừng giao dịch"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        style: {
                            gap: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                checked: tradingType === home/* TradeType.TRADING */.YL.TRADING,
                                scale: "sm",
                                onClick: function() {
                                    dispatch((0,actions/* fetchTradingType */.hN)({
                                        tradingType: home/* TradeType.TRADING */.YL.TRADING
                                    }));
                                    dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
                                        pageActiveManage: 0
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                bold: true,
                                children: "Đang giao dịch"
                            })
                        ]
                    })
                ]
            }),
            (isTablet || isMobile) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: [
                    "100%",
                    ,
                    "auto"
                ],
                flexDirection: "column",
                style: {
                    gap: "12px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textDisabled",
                        textTransform: "uppercase",
                        children: "Trạng th\xe1i"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: [
                            "100%",
                            ,
                            "300px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select, {
                            options: [
                                {
                                    label: "Tất cả",
                                    value: home/* TradeType.ALL */.YL.ALL
                                },
                                {
                                    label: "Ngừng giao dịch",
                                    value: home/* TradeType.STOPTRANSACTION */.YL.STOPTRANSACTION
                                },
                                {
                                    label: "Đang giao dịch",
                                    value: home/* TradeType.TRADING */.YL.TRADING
                                }
                            ],
                            defaultOptionIndex: 0,
                            onOptionChange: handleChangeSelect
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                width: [
                    "100%",
                    ,
                    "auto"
                ],
                style: {
                    gap: "1rem"
                },
                children: [
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_csv.CSVLink, {
                        data: dataCsv,
                        headers: headers,
                        filename: "Quanly_".concat((0,renderDate/* renderDate */.m)(), ".csv"),
                        className: "btn btn-primary",
                        target: "_blank",
                        separator: ",",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            width: [
                                "100%",
                                ,
                                "auto"
                            ],
                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Download/* default */.Z, {}),
                            children: "Tải xuống"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: [
                            "100%",
                            ,
                            "250px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default */.Z, {
                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                color: "text90"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                value: searchQuery,
                                placeholder: "T\xecm kiếm theo m\xe3 cổ phiếu",
                                onChange: function(evt) {
                                    return handleChangeSearchQuery(evt);
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Manage_Filter = (Filter);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButtonV2.tsx
var IconButtonV2 = __webpack_require__(82274);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Pencil.tsx
var Pencil = __webpack_require__(16080);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/views/Home/components/TextWithTooltipV2.tsx



var TextWithTooltipV2 = function(param) {
    var title = param.title, tooltipText = param.tooltipText;
    var ref = (0,useTooltip/* default */.Z)(tooltipText, {
        placement: "top"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        alignItems: "center",
        zIndex: 20,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                ref: targetRef,
                children: title
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var components_TextWithTooltipV2 = (TextWithTooltipV2);

// EXTERNAL MODULE: ./src/config/constants/stocks/index.ts
var constants_stocks = __webpack_require__(98289);
;// CONCATENATED MODULE: ./src/views/Home/Manage/hook/usePausing.tsx














var usePausing = function(contract, account, chainId) {
    var ref = (0,useToast/* useToast */.p)(), toastSuccess = ref.toastSuccess, toastError = ref.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var handlePausing = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(alertText, stockSymbol, callFunction) {
            var tx, receipt, e, config, makertplaceAddress, dataStocks;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPendingTx(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            8
                        ]);
                        return [
                            4,
                            callWithMarketGasPrice(contract, callFunction, [])
                        ];
                    case 2:
                        tx = _state.sent();
                        return [
                            4,
                            tx.wait()
                        ];
                    case 3:
                        receipt = _state.sent();
                        if (receipt.status) {
                            toastSuccess(alertText, /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "#777E90",
                                                    fontWeight: 700
                                                },
                                                children: "M\xe3 cổ phiếu: "
                                            }),
                                            stockSymbol
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                                        txHash: receipt.transactionHash
                                    })
                                ]
                            }));
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        e = _state.sent();
                        console.error(e);
                        toastError(t("Thất bại!"), t("Đ\xe3 xảy ra lỗi, vui l\xf2ng thử lại!"));
                        setPendingTx(false);
                        return [
                            3,
                            8
                        ];
                    case 5:
                        return [
                            4,
                            (0,constants_stocks.getStocksConfig)(chainId)
                        ];
                    case 6:
                        config = _state.sent();
                        makertplaceAddress = (0,addressHelpers/* getAddress */.Kn)(contracts/* default.marketplace */.Z.marketplace, chainId);
                        return [
                            4,
                            (0,fetchDataStocks/* getDataStocks */.cX)(config, chainId, account, makertplaceAddress)
                        ];
                    case 7:
                        dataStocks = _state.sent();
                        dispatch((0,actions/* fetchDataStocks */.$E)(dataStocks));
                        setPendingTx(false);
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(alertText, stockSymbol, callFunction) {
            return _ref.apply(this, arguments);
        };
    }(), [
        callWithMarketGasPrice,
        contract,
        chainId,
        toastSuccess,
        account,
        t,
        toastError
    ]);
    return {
        handlePausing: handlePausing,
        pendingTx: pendingTx
    };
};

;// CONCATENATED MODULE: ./src/views/Home/Manage/Row.tsx










var Row = function(param) {
    var item = param.item, account = param.account, chainId = param.chainId;
    var displayTooltipCode = function displayTooltipCode() {
        setIsTooltipDisplayed(true);
        setTimeout(function() {
            setIsTooltipDisplayed(false);
        }, 3000);
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isTooltipDisplayed = ref3[0], setIsTooltipDisplayed = ref3[1];
    var ref4 = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref4.isMobile, isDesktop = ref4.isDesktop;
    var renderAddress = function(address) {
        return "".concat(address === null || address === void 0 ? void 0 : address.substring(0, 4), "...").concat(address === null || address === void 0 ? void 0 : address.substring((address === null || address === void 0 ? void 0 : address.length) - 4));
    };
    var handleCoppy = function(address) {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(address).then(function() {
                return displayTooltipCode();
            });
        } else if (document.queryCommandSupported("copy")) {
            var ele = document.createElement("textarea");
            ele.value = address;
            document.body.appendChild(ele);
            ele.select();
            document.execCommand("copy");
            document.body.removeChild(ele);
            displayTooltipCode();
        }
    };
    var contract = (0,useContract/* useStocks */.k3)(item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.address);
    var ref5 = usePausing(contract, account, chainId), handlePausing = ref5.handlePausing, pendingTx = ref5.pendingTx;
    var renderNameCompany = function(name) {
        if ((name === null || name === void 0 ? void 0 : name.length) > 84) {
            return "".concat(name === null || name === void 0 ? void 0 : name.substring(0, 84), "...");
        }
        return name;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* ContainerLink */.LN, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/shareholders/".concat(item === null || item === void 0 ? void 0 : (ref1 = item.contract) === null || ref1 === void 0 ? void 0 : ref1.address),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Mask */.zd, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* ContainerRow */.vo, {
                isHeader: false,
                style: {
                    position: "absolute"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "M\xe3 cổ phiếu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: item === null || item === void 0 ? void 0 : item.symbol
                            })
                        ]
                    }),
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: [
                            "flex-start",
                            ,
                            "center"
                        ],
                        flexDirection: [
                            "column",
                            ,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "T\xean c\xf4ng ty"
                            }),
                            (item === null || item === void 0 ? void 0 : item.companyName.length) > 84 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltipV2, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    maxWidth: [
                                        "100%",
                                        ,
                                        ,
                                        "100%"
                                    ],
                                    textAlign: [
                                        "justify",
                                        ,
                                        ,
                                        "left"
                                    ],
                                    paddingRight: [
                                        "0px",
                                        ,
                                        ,
                                        "12px"
                                    ],
                                    width: "100%",
                                    style: {
                                        wordBreak: "break-word"
                                    },
                                    color: isMobile ? "text" : "textSubtle",
                                    bold: !isMobile,
                                    children: renderNameCompany(item === null || item === void 0 ? void 0 : item.companyName)
                                }),
                                tooltipText: item === null || item === void 0 ? void 0 : item.companyName
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                marginTop: "0.5rem",
                                maxWidth: [
                                    "100%",
                                    ,
                                    ,
                                    "100%"
                                ],
                                textAlign: [
                                    "justify",
                                    ,
                                    ,
                                    "left"
                                ],
                                paddingRight: [
                                    "0px",
                                    ,
                                    ,
                                    "12px"
                                ],
                                width: "100%",
                                style: {
                                    wordBreak: "break-word"
                                },
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: item === null || item === void 0 ? void 0 : item.companyName
                            })
                        ]
                    }) : (item === null || item === void 0 ? void 0 : item.companyName.length) > 30 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: [
                            "flex-start",
                            ,
                            "center"
                        ],
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "T\xean c\xf4ng ty"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                textAlign: [
                                    "justify",
                                    ,
                                    ,
                                    "left"
                                ],
                                paddingRight: [
                                    "0px",
                                    ,
                                    ,
                                    "12px"
                                ],
                                style: {
                                    wordBreak: "break-word"
                                },
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: item === null || item === void 0 ? void 0 : item.companyName
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: [
                            "flex-start",
                            ,
                            "center"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "T\xean c\xf4ng ty"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                textAlign: [
                                    "justify",
                                    ,
                                    ,
                                    "left"
                                ],
                                paddingRight: [
                                    "0px",
                                    ,
                                    ,
                                    "12px"
                                ],
                                style: {
                                    wordBreak: "break-word"
                                },
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: item === null || item === void 0 ? void 0 : item.companyName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: [
                            "space-between",
                            ,
                            "flex-end"
                        ],
                        alignItems: "center",
                        paddingRight: [
                            "0rem",
                            ,
                            "2rem"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "Mệnh gi\xe1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: (0,formatNumber/* formatNumber */.u)(item === null || item === void 0 ? void 0 : item.issuePrice)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        paddingRight: [
                            "0px",
                            ,
                            ,
                            "0.5rem"
                        ],
                        alignItems: "center",
                        justifyContent: [
                            "space-between",
                            ,
                            "center"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                display: [
                                    "block",
                                    ,
                                    ,
                                    "none"
                                ],
                                bold: true,
                                children: "Địa chỉ contract"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                style: {
                                    gap: "12px"
                                },
                                position: "relative",
                                zIndex: 20,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "100%",
                                        textAlign: [
                                            "right",
                                            ,
                                            ,
                                            "left"
                                        ],
                                        color: isMobile ? "text" : "textSubtle",
                                        bold: !isMobile,
                                        children: renderAddress(item === null || item === void 0 ? void 0 : (ref2 = item.contract) === null || ref2 === void 0 ? void 0 : ref2.address)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            var ref;
                                            return handleCoppy(item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.address);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Tooltip */.u, {
                                        isTooltipDisplayed: isTooltipDisplayed,
                                        children: "Copied"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: [
                            "space-between",
                            ,
                            "flex-end"
                        ],
                        alignItems: "center",
                        paddingRight: [
                            "0rem",
                            ,
                            "2rem"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                style: {
                                    display: isDesktop ? "none" : "block"
                                },
                                zIndex: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltip, {
                                    title: "TSLPH",
                                    tooltipText: "Tổng số lượng ph\xe1t h\xe0nh"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: (0,formatNumber/* formatNumber */.u)(item === null || item === void 0 ? void 0 : item.totalReleaseStocks)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: [
                            "space-between",
                            ,
                            "flex-end"
                        ],
                        alignItems: "center",
                        paddingRight: [
                            "0rem",
                            ,
                            "2rem"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                style: {
                                    display: isDesktop ? "none" : "block"
                                },
                                zIndex: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltip, {
                                    title: "TGTCP",
                                    tooltipText: "Tổng gi\xe1 trị cổ phiếu"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: isMobile ? "text" : "textSubtle",
                                bold: !isMobile,
                                children: (0,formatNumber/* formatNumber */.u)(item === null || item === void 0 ? void 0 : item.totalValueOfStocks)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        zIndex: 20,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: [
                                "space-between",
                                ,
                                ,
                                "space-between"
                            ],
                            alignItems: "center",
                            style: {
                                gap: "1rem"
                            },
                            children: [
                                !(item === null || item === void 0 ? void 0 : item.isAdmin) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonV2/* default */.Z, {
                                    scale: "sm",
                                    disabled: !(item === null || item === void 0 ? void 0 : item.isAdmin),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButtonV2/* default */.Z, {
                                    scale: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/edit/".concat(item === null || item === void 0 ? void 0 : item.contract.address),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pencil/* default */.Z, {})
                                    })
                                }),
                                !(item === null || item === void 0 ? void 0 : item.isAdmin) ? (item === null || item === void 0 ? void 0 : item.isPause) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltipV2, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        width: "100%",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            paddingX: "8px",
                                            height: "40px",
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "100%"
                                            ],
                                            disabled: !(item === null || item === void 0 ? void 0 : item.isAdmin) || pendingTx,
                                            onClick: function() {
                                                var ref;
                                                return handlePausing("Tiếp tục giao dịch th\xe0nh c\xf4ng!", item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.symbol, "continueTrading");
                                            },
                                            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                                spin: true,
                                                color: "#9395A4"
                                            }) : "",
                                            children: "Tiếp tục giao dịch"
                                        })
                                    }),
                                    tooltipText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "red",
                                        children: "Bạn kh\xf4ng phải chủ sở hữu cổ phiếu"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltipV2, {
                                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        width: "100%",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            paddingX: "8px",
                                            variant: "danger",
                                            height: "40px",
                                            width: [
                                                "100%",
                                                ,
                                                ,
                                                "100%"
                                            ],
                                            disabled: !(item === null || item === void 0 ? void 0 : item.isAdmin) || pendingTx,
                                            onClick: function() {
                                                var ref;
                                                return handlePausing("Ngừng giao dịch th\xe0nh c\xf4ng!", item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.symbol, "pauseTrading");
                                            },
                                            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                                spin: true,
                                                color: "#9395A4"
                                            }) : "",
                                            children: "Ngừng giao dịch"
                                        })
                                    }),
                                    tooltipText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "red",
                                        children: "Bạn kh\xf4ng phải chủ sở hữu cổ phiếu"
                                    })
                                }) : (item === null || item === void 0 ? void 0 : item.isPause) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    width: "100%",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        paddingX: "8px",
                                        height: "40px",
                                        width: [
                                            "100%",
                                            ,
                                            ,
                                            "100%"
                                        ],
                                        disabled: !(item === null || item === void 0 ? void 0 : item.isAdmin) || pendingTx,
                                        onClick: function() {
                                            var ref;
                                            return handlePausing("Tiếp tục giao dịch th\xe0nh c\xf4ng!", item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.symbol, "continueTrading");
                                        },
                                        endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            spin: true,
                                            color: "#9395A4"
                                        }) : "",
                                        children: "Tiếp tục giao dịch"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    width: "100%",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        paddingX: "8px",
                                        variant: "danger",
                                        height: "40px",
                                        width: [
                                            "100%",
                                            ,
                                            ,
                                            "100%"
                                        ],
                                        disabled: !(item === null || item === void 0 ? void 0 : item.isAdmin) || pendingTx,
                                        style: {
                                            backgroundColor: "#EF1616"
                                        },
                                        onClick: function() {
                                            var ref;
                                            return handlePausing("Ngừng giao dịch th\xe0nh c\xf4ng!", item === null || item === void 0 ? void 0 : (ref = item.contract) === null || ref === void 0 ? void 0 : ref.symbol, "pauseTrading");
                                        },
                                        endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            spin: true,
                                            color: "#9395A4"
                                        }) : "",
                                        children: "Ngừng giao dịch"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Manage_Row = (Row);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TotalStocks.tsx
var TotalStocks = __webpack_require__(83906);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TotalRelease.tsx
var TotalRelease = __webpack_require__(68938);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TotalPrice.tsx
var TotalPrice = __webpack_require__(85656);
// EXTERNAL MODULE: ./src/views/Home/components/Card.tsx
var Card = __webpack_require__(11447);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
;// CONCATENATED MODULE: ./src/views/Home/Manage/WrappedCard.tsx






var WrappedCard = function(param) {
    var data = param.data, isLoading = param.isLoading;
    console.log("aksjkalsjl", data);
    var countTotalIssue = data.reduce(function(acc, curr) {
        acc += new bignumber/* default */.Z(curr === null || curr === void 0 ? void 0 : curr.totalReleaseStocks).toNumber();
        return acc;
    }, 0);
    var countTotalValueOfStocks = data.reduce(function(acc, curr) {
        acc += new bignumber/* default */.Z(curr === null || curr === void 0 ? void 0 : curr.totalValueOfStocks).toNumber();
        return acc;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* ContainerCard */._K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalStocks/* default */.Z, {
                    width: "42px"
                }),
                title: "Tổng cổ phiếu ph\xe1t h\xe0nh",
                value: countTotalIssue,
                unit: "Cổ phiếu",
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalRelease/* default */.Z, {
                    width: "42px"
                }),
                title: "Tổng đơn vị ph\xe2n phối",
                value: data === null || data === void 0 ? void 0 : data.length,
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPrice/* default */.Z, {
                    width: "42px"
                }),
                title: "Tổng tiền cổ phiếu đ\xe3 ph\xe1t h\xe0nh",
                value: countTotalValueOfStocks,
                unit: "VND",
                isLoading: isLoading
            })
        ]
    });
};
/* harmony default export */ var Manage_WrappedCard = (WrappedCard);

;// CONCATENATED MODULE: ./src/views/Home/Manage/index.tsx














var Manage = function(param) {
    var tradingType = param.tradingType, isLoading = param.isLoading, dataStocks = param.dataStocks, pageActiveManage = param.pageActiveManage, chainId = param.chainId, account = param.account;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isTablet = ref1.isTablet, isMobile = ref1.isMobile;
    var ref2 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(dataStocks)), currentItems = ref2[0], setCurrentItems = ref2[1];
    var ref3 = (0,react.useState)(0), pageCount = ref3[0], setPageCount = ref3[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var filterData = (0,react.useMemo)(function() {
        switch(tradingType){
            case home/* TradeType.ALL */.YL.ALL:
                {
                    return (0,_to_consumable_array/* default */.Z)(dataStocks);
                }
            case home/* TradeType.STOPTRANSACTION */.YL.STOPTRANSACTION:
                {
                    return (0,_to_consumable_array/* default */.Z)(dataStocks.filter(function(dt) {
                        return dt === null || dt === void 0 ? void 0 : dt.isPause;
                    }));
                }
            case home/* TradeType.TRADING */.YL.TRADING:
                {
                    return (0,_to_consumable_array/* default */.Z)(dataStocks.filter(function(dt) {
                        return !(dt === null || dt === void 0 ? void 0 : dt.isPause);
                    }));
                }
            default:
                {
                    return (0,_to_consumable_array/* default */.Z)(dataStocks);
                }
        }
    }, [
        dataStocks,
        tradingType,
        account
    ]);
    var filterSearchData = (0,react.useMemo)(function() {
        if (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) {
            return (0,_to_consumable_array/* default */.Z)(filterData.filter(function(dt) {
                return dt === null || dt === void 0 ? void 0 : dt.symbol.toLowerCase().includes(searchQuery.toLowerCase());
            }));
        }
        return (0,_to_consumable_array/* default */.Z)(filterData);
    }, [
        searchQuery,
        filterData,
        account
    ]);
    var handlePageClick = function(event) {
        dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
            pageActiveManage: event.selected
        }));
    };
    (0,react.useEffect)(function() {
        var item = pageActiveManage * config/* ITEMSPERPAGE */.LW % filterSearchData.length;
        var endOffset = item + config/* ITEMSPERPAGE */.LW;
        setCurrentItems(filterSearchData.slice(item, endOffset));
        setPageCount(Math.ceil(filterSearchData.length / config/* ITEMSPERPAGE */.LW));
    }, [
        pageActiveManage,
        config/* ITEMSPERPAGE */.LW,
        filterSearchData,
        account
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        height: "100%",
        flexDirection: "column",
        style: {
            gap: "2rem"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Manage_WrappedCard, {
                data: dataStocks,
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Manage_Filter, {
                searchQuery: searchQuery,
                tradingType: tradingType,
                handleChangeQuery: function(newQuery) {
                    setSearchQuery(newQuery);
                    dispatch((0,actions/* fetchNumberPageCurrent */.zf)({
                        pageActiveManage: 0
                    }));
                },
                manegeTempConfig: filterSearchData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                flexWrap: "wrap",
                height: "auto",
                style: {
                    gap: isTablet || isMobile ? "1rem" : "0rem"
                },
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* ContainerRow */.vo, {
                        isHeader: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: "M\xe3 cổ phiếu"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: "T\xean c\xf4ng ty"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: [
                                    "space-between",
                                    ,
                                    "flex-end"
                                ],
                                paddingRight: [
                                    "0rem",
                                    ,
                                    "2rem"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: "Mệnh gi\xe1"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: [
                                    "space-between",
                                    ,
                                    "center"
                                ],
                                paddingRight: [
                                    "0rem",
                                    ,
                                    "0.5rem"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: "Địa chỉ contract"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: [
                                    "space-between",
                                    ,
                                    "flex-end"
                                ],
                                paddingRight: [
                                    "0rem",
                                    ,
                                    "1rem"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltip, {
                                    title: "TSLPH",
                                    tooltipText: "Tổng số lượng ph\xe1t h\xe0nh"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: [
                                    "space-between",
                                    ,
                                    "flex-end"
                                ],
                                paddingRight: [
                                    "0rem",
                                    ,
                                    "1rem"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextWithTooltip, {
                                        title: "TGTCP",
                                        tooltipText: "Tổng gi\xe1 trị cổ phiếu"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%"
                            })
                        ]
                    }),
                    (currentItems === null || currentItems === void 0 ? void 0 : currentItems.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            height: 115,
                            width: 115,
                            src: "/images/logo/no_data.png",
                            alt: "no data"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "auto",
                        flexDirection: "column",
                        style: {
                            gap: isMobile ? "1rem" : "0rem"
                        },
                        children: currentItems === null || currentItems === void 0 ? void 0 : currentItems.map(function(dt) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Manage_Row, {
                                item: dt,
                                account: account,
                                chainId: chainId
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                paddingTop: "3rem",
                width: "100%",
                children: (currentItems === null || currentItems === void 0 ? void 0 : currentItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginate/* Paginate */._, {
                    total: pageCount,
                    pageSize: config/* ITEMSPERPAGE */.LW,
                    pageActive: pageActiveManage,
                    handlePageClick: handlePageClick
                })
            })
        ]
    });
};
/* harmony default export */ var Home_Manage = (Manage);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx










var Home = function() {
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    (0,home/* UseCoreManage */.Vz)(chainId, account);
    var ref1 = (0,home/* GetDataHome */.zs)(), activeTab = ref1.activeTab, tradingType = ref1.tradingType, releaseType = ref1.releaseType, isLoading = ref1.isLoading, dataStocks = ref1.dataStocks, pageActiveManage = ref1.pageActiveManage, isOwnerMarketplace = ref1.isOwnerMarketplace;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    mt: "2rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xl",
                        children: activeTab === (home/* HomeTab */.kD === null || home/* HomeTab */.kD === void 0 ? void 0 : home/* HomeTab.MANAGE */.kD.MANAGE) ? "QUẢN L\xdd CỔ PHIẾU" : "PH\xc1T H\xc0NH CỔ PHIẾU"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    mt: "2rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                        activeIndex: activeTab,
                        onItemClick: function(newIndex) {
                            return dispatch((0,actions/* fetchActiveTab */.SU)({
                                activeTab: newIndex
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                children: "Quản l\xfd"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                children: "Ph\xe1t h\xe0nh"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    mt: "2rem",
                    children: activeTab === (home/* HomeTab */.kD === null || home/* HomeTab */.kD === void 0 ? void 0 : home/* HomeTab.MANAGE */.kD.MANAGE) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Manage, {
                        tradingType: tradingType,
                        isLoading: isLoading,
                        dataStocks: dataStocks,
                        pageActiveManage: pageActiveManage,
                        account: account,
                        chainId: chainId
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Release, {
                        releaseType: releaseType,
                        isOwnerMarketplace: isOwnerMarketplace
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx






var IndexPage = function() {
    var isLoggedIn = (0,react.useContext)(AuthContext/* AuthContext */.V).isLoggedIn;
    return isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth/* default */.Z, {});
};
IndexPage.chains = config/* SUPPORTED_PAGE */.Ac;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,372,746,747,3,368,786,753,81,918,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);